module.exports = function() { return __webpack_public_path__ + "intro_img1.1-ofdSFexPgFseChdDrk.svg";};